import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router/router'
import httpServe from '../httpserve/httpServe.js'
import preventReClick from './assets/js/utils.js'
import {
	message
} from 'element-ui'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts //将echarts作为全局变量加入Vue
Vue.use(preventReClick);
Vue.config.productionTip = false
Vue.prototype.$api = httpServe; //设置全局变量
Vue.prototype.$message = message
Vue.use(ElementUI);
new Vue({
	router,
	render: h => h(App),
}).$mount('#app')

let basImgUrl = "https://www.am-mes.cn/"
let upUrl = "https://www.am-mes.cn/charge/"
Vue.prototype.$basImgUrl = basImgUrl
Vue.prototype.$upUrl = upUrl

function newNumber(num1, num2) {
	const factor = 100000000;
	let num = 0
	num = Math.round((num1 * factor) + (num2 * factor));
	return (num) / factor;
}
Vue.prototype.$newNumber = newNumber